"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInput_1 = require("../genericInput/GenericInput");
exports.InputFieldWithHyphen = function (_a) {
    var formData = _a.formData;
    var label = formData.label, required = formData.required, id = formData.id, onChange = formData.onChange, value = formData.value, rawErrors = formData.rawErrors;
    var currentError = react_1.useMemo(function () { var _a; return ((_a = rawErrors) === null || _a === void 0 ? void 0 : _a.length) > 0 && rawErrors[0]; }, [rawErrors]);
    var formatString = function (value) {
        var _a;
        if (!((_a = value) === null || _a === void 0 ? void 0 : _a.length)) {
            return '';
        }
        var val = value.replace(/-/g, '');
        return val.substring(0, val.length - 1) + '-' + val.substring(val.length - 1);
    };
    var handleChange = react_1.useCallback(function (e) {
        var formattedString = formatString(e.target.value);
        onChange(formattedString);
    }, [value]);
    var inputValue = value.includes('-') ? value : formatString(value);
    return (<GenericInput_1.default label={label} required={required} id={id} onChange={handleChange} value={inputValue} currentError={currentError}/>);
};
exports.default = exports.InputFieldWithHyphen;
